import { useContext } from "react"

import { Button } from "@/components/Button/Button.tsx"
import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { Horizontal } from "@/components/Flex.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"

export const RetryAnonymousMirroring = (props: {
  isLast: boolean
}) => {
  const context = useOrgContext()
  const taskModel = useContext(TaskViewModelContext)

  if (!props.isLast || !taskModel) {
    return null
  }

  return (
    <Horizontal alignItems="flex-end">
      <AgentMessageContainer>
        <Button
          kind="primary"
          onClick={() => context.queries.apiClient.setRepositoryAccess(taskModel.taskId, "Anonymous")}
        >
          Retry mirroring
        </Button>
      </AgentMessageContainer>
    </Horizontal>
  )
}
